import { useTranslation } from "react-i18next";
import { SupplierRelationDto } from "../../../autogen/bff-api";

export const useSupplierRelationLabels = (): Record<SupplierRelationDto, string> => {
  const { t } = useTranslation();
  return {
    [SupplierRelationDto.ActiveContract]: t("Active contract"),
    [SupplierRelationDto.EarlierContract]: t("Earlier contract"),
    [SupplierRelationDto.InvitedBefore]: t("Invited before"),
    [SupplierRelationDto.DeliveredBid]: t("Delivered a bid"),
    [SupplierRelationDto.Won]: t("Won"),
  };
};
